module.exports = function() {
  return new Worker(__webpack_public_path__ + "d9502913992e57da1efc.worker.js");
};